import { Flex, Stack, Heading, Text, Divider } from "@chakra-ui/react";
import SignupCheck from "./SignupCheck";

const SignupCard = () => {
  return (
    <Flex
      minH={"70vh"}
      align={"center"}
      justify={"center"}
      bg={"#141416"}
      marginTop={10}
      borderRadius={8}
      padding={2}
    >
      <Stack spacing={8} mx={"auto"} w={"lg"} px={4}>
        <Stack>
          <Heading fontSize={"xl"} fontWeight="regular">
            Welcome to
          </Heading>
          <Text fontSize={"2xl"} fontWeight="bold">
            <Text as="span" color="#22C55E">
              Bonatra
            </Text>{" "}
            Healthcare Private Ltd
          </Text>
          <Divider orientation="horizontal" mx={8} />
        </Stack>
        <SignupCheck />
      </Stack>
    </Flex>
  );
};

export default SignupCard;
